import { useCallback, useEffect, useRef } from 'react';
import { useCheckLoadedAndShow } from './useCheckLoadedAndShow';
import { postParentWindowMessage } from '../../../../utils/post-message';
/**
 * Shows the webview when the page is presenting a login form.
 *
 * Use this hook for web applications that do not change the
 * page URL on login success (i.e. single page applications or SPAs).
 * If the URL changes for login success, use `useCheckLoadedAndShow`.
 *
 * @param cb - Optional callback to fire after the page is loaded.
 *             VERY IMPORTANT: This callback must be a constant reference
 *             (i.e. don't declare it inside a React component unless memoized)
 *             in order to behave correctly.
 */
export default function useCheckLoadedAndShowSPA(cb) {
    var isPageLoadedRef = useRef(false);
    // Poll the webview for cookies once the DOM is loaded.
    useEffect(function () {
        var interval = setInterval(function () {
            if (!isPageLoadedRef.current)
                return;
            postParentWindowMessage({
                type: 'PINWHEEL_INTERNAL_COMM_UP',
                eventName: 'setos_request',
            });
        }, 1000);
        return function () { return clearInterval(interval); };
    }, []);
    // VERY IMPORTANT:
    // Memoize this callback so it maintains a reference to the same object
    // and thus won't re-trigger useEffect's within `useCheckLoadedAndShow`.
    var memoizedCallback = useCallback(function () {
        isPageLoadedRef.current = true;
        return cb ? cb() : null;
        // Dependency array is purposefully empty so it never changes reference.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useCheckLoadedAndShow(memoizedCallback);
}
